import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { map } from 'rxjs/operators';

@Injectable()
export class ApplicationsService {
  constructor(private dataService: DataService) {}

  getByDates(from: Date, to: Date) {
    return this.dataService
      .getDownloadable(`reporting/applications/by-dates`, { from, to })
      .pipe(map((blob) => blob));
  }
}
